const LeaderboardItem = ({ user }) => {
  const { rank, student_name, quizMark, assignmentMark, totalMark } = user || {};

  return (
    <tr className="border-b border-slate-600/50">
      <td className="table-td text-center">{rank}</td>
      <td className="table-td text-center">{student_name}</td>
      <td className="table-td text-center">{quizMark}</td>
      <td className="table-td text-center">{assignmentMark}</td>
      <td className="table-td text-center">{totalMark}</td>
    </tr>
  );
};

export default LeaderboardItem;
